var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-tel-input',{attrs:{"value":_vm.value,"inputOptions":{ showDialCode: true },"dropdownOptions":{ tabindex: -1, showFlags: true, showDialCodeInList: true },"validCharactersOnly":true,"preferredCountries":['FR', 'ES', 'BE', 'DE']},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }